import { Component, OnInit } from '@angular/core';
import { SearchService, AdvancedSearchParams, ScrollService,SongsService } from '../api';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {Router,NavigationExtras } from '@angular/router';
import { Globals } from '../app.globals';
declare var $: any;

@Component({
  selector: 'advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.css']
})
export class AdvancedSearchComponent implements OnInit {
    private title: string = '';
    arrow :any = false;
    limit :number = 20;
    private searchTerm: string = '';
    public autoCompleteProductionData: any = new Array<any>();
    private searchTerm2: string = '';
    private noCreditsText: string = '';
    private creditsTypes: Array<any> ;
    private songs: Array<any> ;
    private creditsArray: Array<any> ;
    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;
    public apiUrl: string = new Globals().apiEndpoint;

    constructor(private router: Router,private searchService: SearchService,private songsService: SongsService, private scrollService: ScrollService,private route: ActivatedRoute) {
        if (this.route.snapshot.data['title']) {
            this.title = this.route.snapshot.data['title'];
        }
        window.addEventListener('online', () => {this.onlineOffline1 = true;});
        window.addEventListener('offline', () => {this.onlineOffline1 = false});
    }

    ngOnInit() {
        let creditsTypes = JSON.parse(localStorage.getItem('creditsTypes'));
        let searchTerm = localStorage.getItem('creditSearchTerm');
        if(searchTerm!='') {
            this.searchTerm=searchTerm;
        }
        if (creditsTypes != null && creditsTypes.length>0) {
        this.creditsTypes=creditsTypes;
        }
        var input = document.getElementById("myInput2");
        input.addEventListener("keyup", function(event) {
            event.preventDefault();
            if(event.keyCode === 13) {
                document.getElementById("myBtn2").click();
            }
        });
        this.scrollService.enableScrollIfDisabled();
    }

    handleSearch(event) {
        this.search();
    }

    search() {
        this.creditsTypes = new Array<any>();
        this.blockUI.start('Loading, please wait...');
        this.autoCompleteProductionData = [];
        if(!this.onlineOffline1) {
            this.blockUI.stop();
            return;
        }
        this.noCreditsText = '';
        this.songsService.searchCreditsType(this.searchTerm).subscribe((res) => {
            if (res.length > 0) {
                res.forEach((arrayItem) => {
                    let types = arrayItem;
                    types.credit=types.credit_type;
                    types.clicked=false;
                    types.songs=[];
                    types.loading=false;
                    types.credit_type=types.credit_type.replace("_", " ");
                    types.credit_type=types.credit_type.charAt(0).toUpperCase() + types.credit_type.slice(1);
                    if(types.credit_type == "Artist royalties"){
                        types.credit_type = "Artist/Band Member";
                    }

                    types.credit_type = this.titleCase(types.credit_type);

                    if(types.credit_type == "Arranger"){
                        types.credit_type= "Arranged By";
                    }
                    if(types.credit_type != "Master Ownership"){
                        this.creditsTypes.push(types);
                    }

                });
                this.creditsTypes.sort(function(obj1, obj2) {
                    // Descending:
                    return obj2.total - obj1.total;
                });
                this.songs = _.uniqBy(this.songs, 'id');
                this.setLocalStore('creditsTypes',this.creditsTypes);
                this.blockUI.stop();
                this.searchTerm2 = this.searchTerm.charAt(0).toUpperCase() + this.searchTerm.substring(1) + " Production Credits";
            } else {
                this.blockUI.stop();
                this.noCreditsText = 'No records found.';
                this.searchTerm2 = this.searchTerm.charAt(0).toUpperCase() + this.searchTerm.substring(1) + " Production Credits";
            }
        },
        (error) => {
            console.log(error);
        });
        localStorage.setItem('creditSearchTerm', this.searchTerm);
    }

    titleCase(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
    }

    tabClicked(index,type) {        
        this.creditsTypes.forEach((arrayItem,i) => {
            if(index!=i)
                this.creditsTypes[i].clicked=false;
        });
        this.creditsTypes[index].clicked = !this.creditsTypes[index].clicked;
        this.creditsTypes[index].loading = true;
        if(this.onlineOffline1){
            var that = this;
            //http://api.weget.local/api/songs/search-credits?limit=20&q=Hartog&type=Songs%20Written&page=1
            $.get(this.apiUrl+"songs/search-credits?limit="+this.limit+"&q="+this.searchTerm+"&type="+type+"&page=1").done(
                function(res) {
                    if (res.length > 0) {
                        try{
                            that.creditsTypes[index].songs = [];
                            res.forEach((arrayItem) => {
                                let song = arrayItem;
                                if (song != null) {
                                    song._type = "song";
                                    that.creditsTypes[index].songs.push(song)
                                }
                            });
                            that.songs=[];
                            that.songs=that.creditsTypes[index].songs;
                        } catch(e) {
                            that.blockUI.stop();
                        }
                        that.creditsTypes[index].songs= that.removeSlash();
                        that.creditsTypes[index].songs= that.removeDuplicatCredits();
                        that.blockUI.stop();
                    } else {
                        that.blockUI.stop();
                    }
                    that.creditsTypes[index].loading = false;
                }
            );
        } else {
            this.blockUI.stop();
            this.creditsTypes[index].loading = false;
        }
    }

    setLocalStore($type,$data) {
        localStorage.setItem($type, JSON.stringify($data));
    }

    navigate(type: string,total:number) {
        this.scrollService.closeSideNav();
        let navigationExtras: NavigationExtras = {
            queryParams: { 'q': this.searchTerm,'type': "AS",'subtype':type,'total':total},
        };
        this.router.navigate(['/songs'], navigationExtras);
    }

    removeSlash() {
        if (this.songs) {
            for (var i = 0; i < this.songs.length; i++) {
                if (typeof this.songs[i].credits === "object" && this.songs[i].credits != null) {
                    for (var j = 0; j < this.songs[i].credits.length; j++) {
                        this.songs[i].credits[j].credit_type = this.songs[i].credits[j].credit_type.replace("_", " ");
                        this.songs[i].credits[j].credit_type = this.songs[i].credits[j].credit_type.charAt(0).toUpperCase() + this.songs[i].credits[j].credit_type.slice(1);
                    }
                }
            }
        }
        return this.songs;
    }

    removeDuplicatCredits() {
        for (let i = 0; i < this.songs.length; i++) {
            for (let e = 0; e < 4; e++) {
                if(this.songs[i].writers) {
                    this.songs[i].writers.forEach((item, index) => {
                        // Compare the writer names and remove the duplicate record
                        if (index !== this.songs[i].writers.findIndex(i => i.writer === item.writer)) {
                            this.songs[i].writers.splice(index, 1);
                        }
                    });
                }
            }
            for (let f = 0; f < 4; f++) {
                this.creditsArray = new Array<any>();
                if(this.songs[i].credits) {
                    this.songs[i].credits.forEach((item, index) => {
                        if (index !== this.songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                            this.creditsArray.push(this.songs[i].credits[index]);
                        }
                    });
                }
            }
            for (let j = 0; j < this.creditsArray.length; j++) {
                for (let k = 0; k < this.songs[i].credits.length; k++) {
                    if (this.songs[i].credits[k].credit_type == this.creditsArray[j].credit_type) {
                        if (!(this.songs[i].credits[k].name.includes(this.creditsArray[j].name))) {

                            if (!this.songs[i].credits[k].values) {
                                this.songs[i].credits[k]["values"] = [];
                            }
                            if (!(this.songs[i].credits[k].values.includes(this.songs[i].credits[k].name))) {
                                this.songs[i].credits[k].values.push(this.songs[i].credits[k].name);
                            }
                            if (!(this.songs[i].credits[k].values.includes(this.creditsArray[j].name))) {
                                this.songs[i].credits[k].values.push(this.creditsArray[j].name);
                            }
                        }
                    }
                }
            }
            for (let f = 0; f < 4; f++) {
              this.creditsArray = new Array<any>();
              if(this.songs[i].credits) {
                  this.songs[i].credits.forEach((item, index) => {
                      if (index !== this.songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                          this.creditsArray.push(this.songs[i].credits[index]);
                          this.songs[i].credits.splice(index, 1);
                      }
                  });
              }
            }
            if(this.songs[i].credits) {
                for (let k = 0; k < this.songs[i].credits.length; k++) {
                    if (!this.songs[i].credits[k].values) {
                        this.songs[i].credits[k]["values"] = [];
                    }
                    if (!(this.songs[i].credits[k].values.includes(this.songs[i].credits[k].name))) {
                        let locationPartt = this.songs[i].credits[k].name.split(",");

                        for (let p = 0; p < locationPartt.length; p++) {
                            locationPartt[p].replace(",", "");
                            this.songs[i].credits[k].values.push(locationPartt[p]);
                        }
                    }
                    if (this.songs[i].credits[k].location && this.songs[i].credits[k].location != null) {
                        this.songs[i].credits[k]["locations"] = [];

                        let locationParts = this.songs[i].credits[k].location.split(",");
                        for (let m = 0; m < locationParts.length; m++) {
                            if (!(locationParts[m].includes("."))) {
                                this.songs[i].credits[k].locations.push(locationParts[m]);
                            }
                            else {
                                let locationParts2 = locationParts[m].split(".");
                                for (let n = 0; n < locationParts2.length; n++) {
                                    this.songs[i].credits[k].locations.push(locationParts2[n]);
                                }
                            }
                        }
                    }
                }
            }

            //publisher array making
            if (!this.songs[i].publishers) {
                this.songs[i]["publisherss"] = [];
                if (this.songs[i].publisher) {
                    var locationParttt = this.songs[i].publisher.split(",");

                    for (let p = 0; p < locationParttt.length; p++) {
                        locationParttt[p].replace(",", "");
                        this.songs[i].publisherss.push(locationParttt[p]);
                    }
                }
            } else {
                this.songs[i]["publisherss"] = [];
                for (let m = 0; m < this.songs[i].publishers.length; m++) {
                    if (this.songs[i].publishers[m].publisher) {
                        this.songs[i].publisherss.push(this.songs[i].publishers[m].publisher);
                    }
                }
            }
        }
        return  this.songs;
    }

    getProductionCreditSuggestion($event) {
        let dataValue = (<HTMLInputElement>document.getElementById('myInput2-input')).value;
        if (dataValue.length > 0) {
            this.songsService.getProductioncredits(dataValue).toPromise().then((res) => {
                let productioncreditsdata = this.searchFromArray(res, dataValue);
                this.autoCompleteProductionData = [].concat(productioncreditsdata);
                let uniqueArray = (names) => names.filter((v,i) => names.indexOf(v) === i);
                this.autoCompleteProductionData = uniqueArray(this.autoCompleteProductionData);
            });
        } else{
          this.autoCompleteProductionData = [];
        }
    }

    searchFromArray(arr, regex) {
        let matches = [], i, count=0;
        if(arr!= null && (typeof arr.length) != "undefined" && arr.length != null){
            for (i = 0; i < arr.length; i++) {
                if (arr[i].name != null && arr[i].name.match(new RegExp(regex, "i"))) {
                  matches.push(arr[i].name);
                  count++;
                  if(count == 10){
                    return matches;
                  }
                }
              }
        }
        return matches;
    };

    onClear() {
        this.searchTerm = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/advanced-search/advanced-search.component.ts